module.exports = __webpack_public_path__ + "img/Kd.3186bf00.png";